bam-helpbox {
  display: flex;
  justify-content: flex-end;
  right: 1.5rem;
  bottom: 1.5rem;
  width: 100%;

  @include tablet() {
    right: 24px;
    width: 100%;
  }

  .helpbox__content-wrapper {
    display: block;
    border-radius: 0.75rem;
    background-color: var(--bal-color-grey-1);
    text-align: left;
    position: absolute;
    bottom: 56px;
    right: 0;
    width: 288px;
    height: auto;
    opacity: 1;
    transition: transform 0.4s ease-out;
    transform: scale(1);
    opacity: 1;
    visibility: visible;
    transform-origin: bottom right;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

    @include tablet() {
      width: 440px;
      bottom: 60px;
    }

    &.is-hide {
      transform: scale(0);
      opacity: 0;
      visibility: hidden;
      transition: transform 0.2s ease-in;
      transform-origin: bottom right;
    }
  }

  .helpbox__contact-wrapper {
    display: flex;
    flex-direction: column;
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
    padding: 1rem 1rem 1rem;
    background-color: var(--bal-color-grey-1);

    &.is-empty {
      padding: 0.25rem 1rem 0.5rem;
      background-color: var(--bal-color-white);
    }

    .helpbox__contact-consultant {
      display: flex;
    }

    .helpbox__contact-image {
      width: 120px !important;
      border-radius: 4px;
    }

    a.consultant-link {
      &:hover {
        h5 {
          color: var(--bal-color-light-blue-5) !important;
        }

      }
    }

    .phone-text {
      display: block;
      font-size: 14px !important;
    }

    .button-label {
      text-align: left;
    }
  }

  .helpbox__linklist-wrapper {
    padding: 0 1rem 1rem;
    background-color: var(--bal-color-white);
    border-bottom-left-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }

  .helpbox__linklist-wrapper:empty{
    background-color: var(--bal-color-grey-1);
  }

  &:not(.is-consultant) {
    .helpbox__linklist-wrapper {
      &:after {
        position: absolute;
        content: '';
        bottom: -4px;
        right: 6.5rem;
        width: 8px;
        height: 8px;
        background-color: var(--bal-color-white);
        transform: rotate(45deg);
      }
    }
  }

  &.is-consultant {
    .helpbox__content-wrapper {

      @include tablet() {
        width: 440px;
      }
    }
  }

  bal-list {
    .title {
      font-size: 1rem !important;
      line-height: 1.5rem !important;
    }
  }

  bal-button {
    .button.is-info {
      background-color: var(--bal-color-white) !important;
    }

    &.text-small {
      a {
        font-size: var(--bal-button-small-font-size);
      }
    }
  }

  .helpbox__backdrop {
    height: 500%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 13, 110, 0.8);
    z-index: -1;
  }
}
